import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import hasDom from 'has-dom'
import styles from './styles'
import { getContentStyles, getModalStyles } from './helpers'

class ModalPortal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount (props) {
    if (!hasDom()) return

    this.container = document.createElement('div')
    document.body.appendChild(this.container)
  }

  componentWillUnmount () {
    document.body.removeChild(this.container)
  }

  renderModal () {
    return (
      <div style={getModalStyles(this.props)}>
        <a style={styles.overlay} href={'#'} onClick={this.props.onDismiss} />
        <div style={getContentStyles(this.props)}>
          {this.props.children}
        </div>
      </div>
    )
  }

  render () {
    if (!this.container) return null
    return ReactDOM.createPortal(this.renderModal(), this.container)
  }
}

ModalPortal.propTypes = {
  children: PropTypes.any,
  visible: PropTypes.bool,
  onDismiss: PropTypes.func
}

export default ModalPortal
